import { Injectable, OnInit } from "@angular/core";
import { Store } from "./store";
import { AppStoreModel } from "./app.store.model";
import { AppGlobalConfigAction } from "./actions/app-global-config.action";
import { HttpClient } from "@angular/common/http";
import { AppSessionAction } from "./actions/app-session.action";
import { AuthService } from "./../services/auth.service";

@Injectable({
  providedIn: "root",
})
export class AppStore extends Store<AppStoreModel> {
  globalConfigAction: AppGlobalConfigAction;
  sessionAction: AppSessionAction;

  constructor(private http: HttpClient, private authService: AuthService) {
    super(new AppStoreModel());

    this.globalConfigAction = new AppGlobalConfigAction(
      this.buildScopedGetState("globalConfig"),
      this.buildScopedSetState("globalConfig"),
      this.http
    );

    this.sessionAction = new AppSessionAction(
      this.buildScopedGetState("session"),
      this.buildScopedSetState("session"),
      // this.authService
    );
  }

  //===============================================================
  // ACCIONES QUE MODIFICAN LA UI DE LA APP
  //===============================================================
  openDrawer = () => {
    this.setState({
      ...this.state,
      ui: { ...this.state.ui, drawerOpen: true },
    });
  };

  closeDrawer = () => {
    this.setState({
      ...this.state,
      ui: { ...this.state.ui, drawerOpen: false },
    });
  };

  openDrawerMobile = () => {
    this.setState({
      ...this.state,
      ui: { ...this.state.ui, drawerMobileOpen: true },
    });
  };

  closeDrawerMobile = () => {
    this.setState({
      ...this.state,
      ui: { ...this.state.ui, drawerMobileOpen: false },
    });
  };

  setIsMobile = (value: boolean) => {
    this.setState({
      ...this.state,
      ui: { ...this.state.ui, isMobile: value },
    });
  };

  setShowRightSidenav = (value: boolean) => {
    this.setState({
      ...this.state,
      ui: { ...this.state.ui, showSideNavRight: value },
    });
  };

  drawMenu = () => {
    const appMenu: any[] = this.drawMenuRecursivo(0);
    this.setState({
      ...this.state,
      ui: { ...this.state.ui, appMenu: [...appMenu] },
    });
  };

  private drawMenuRecursivo = (codigoPadre) => {
    let opciones = this.state.session.sessionSTS.opciones
      .filter((o) => o.codigoPadre === codigoPadre)
      .filter((value, index, self) => {
        return self.map((s) => s.codigo).indexOf(value.codigo) === index;
      })
      .sort((a, b) => a.posicion - b.posicion);

    let appMenu: any[] = [];

    opciones.forEach((opcion) => {
      let opcionAppMenu: any = {
        label: opcion.nombre,
        icon: codigoPadre ? "remove" : "label_important",
        items: [...this.drawMenuRecursivo(opcion.codigo)],
      };

      if ((opcion.direccion && codigoPadre) || (!codigoPadre && opcion.direccion == "/")) {
        opcionAppMenu.link = opcion.direccion;
      }

      appMenu.push({ ...opcionAppMenu });
    });

    return appMenu;
  };
}
